import { Typography } from "@mui/material";
import { Map } from "ol";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDateFormatter } from "~/utils/hooks/useDateFormatter";
import { PoiMapItem } from "../types/mapItems";
import { GenericPopup } from "./GenericPopup";

type PoiPopupProps = { data: PoiMapItem; map: Map };
export const PoiPopup = ({ data, map }: PoiPopupProps) => {
  const content = React.useMemo(() => {
    if (!data.description) return undefined;
    return <Typography>{data.description}</Typography>;
  }, [data.description]);
  const { t } = useTranslation();
  const dateformatter = useDateFormatter();

  return (
    <GenericPopup
      title={t(`poi-item-enum:${data.name}`)}
      subheader={dateformatter({ date: data.date })}
      clicked
      content={content}
      map={map}
    />
  );
};
